import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';

// instagram token refresh
type InstagramToken = {
  access_token: string;
  expiresAt: Date;
};
type InstagramRefreshResult = {
  access_token: string;
  // bearer
  token_type: string;
  // in seconds
  expires_in: number;
};
const INSTAGRAM_COLLECTION_NAME = 'instagram-tokens';

export const getInstagramToken = registerQuery({
  type: () => String,
  operationName: 'getInstagramToken',
  resolve: () => {
    return async () => {
      const rawTokenCollection = await getRawCollection<InstagramToken>(INSTAGRAM_COLLECTION_NAME);
      const token = await rawTokenCollection.findOne<InstagramToken>({});
      if (token && !isInstagramTokenExpired(token)) return token.access_token;
      return await refreshInstagramToken(token?.access_token);
    };
  },
  params: [],
});

function isInstagramTokenExpired(token: InstagramToken) {
  const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;
  return token.expiresAt.getTime() - Date.now() < oneWeekInMs;
}

async function refreshInstagramToken(access_token: string | undefined) {
  access_token = access_token ?? process.env.INSTAGRAM_API_TOKEN!;

  const instagramToken = await fetch(
    `https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&&access_token=${access_token}`,
  )
    .then(res => res.json())
    .then(res => res as InstagramRefreshResult);

  if (!instagramToken) throw new Error('instagram token refresh failed');

  const rawTokenCollection = await getRawCollection<InstagramToken>(INSTAGRAM_COLLECTION_NAME);
  rawTokenCollection.deleteMany({});
  await rawTokenCollection.insertOne({
    access_token: instagramToken.access_token,
    expiresAt: new Date(Date.now() + instagramToken.expires_in * 1000),
  });

  return instagramToken.access_token;
}
